import { Controller } from 'stimulus';
import Rails from '@rails/ujs';

/**
 * Поиск грузовика по VIN номеру.
 */
export default class extends Controller {
  static get targets() {
    return ['input', 'trucks'];
  }

  initialize() {
    this.timeout = null;
    this.vinField = this.element.querySelector('[name="vin"]');
    this.truckIdField = this.element.querySelector('[name="truck_id"]');
  }

  connect() {
    const that = this;
    document.body.addEventListener('click', () => { that.trucksTarget.style.display = 'none'; });

    this.inputTarget.addEventListener('keydown', () => this.searchTruck());
    this.inputTarget.addEventListener('paste', () => setTimeout(this.searchTruck(), 250));
  }

  disconnect() {
    this.inputTarget.removeEventListener('keydown', () => this.searchTruck());
    this.inputTarget.removeEventListener('paste', () => this.searchTruck());
  }

  renderNotFound(vin) {
    this.trucksTarget.innerHTML = `<div class="dropdown-item">Грузовик «${vin}» не найден.</div>`;
    this.trucksTarget.style.display = null;
  }

  renderTruck(truck) {
    return `
      <a class="dropdown-item" data-action="click->office--company--search-truck-by-vin#selectTruck" data-truck-id="${truck.id}"
       data-assembly-vin="${truck.assembly_vin}" data-production-vin="${truck.production_vin}">
        ${truck.assembly_vin} :: ${truck.production_vin} :: ${truck.modelname}
      </a>
    `;
  }

  renderTrucks(trucks) {
    const result = [];
    for (const truck of trucks) {
      result.push(this.renderTruck(truck));
    }
    this.trucksTarget.innerHTML = result.join('');
    this.trucksTarget.style.display = null;
  }

  searchTruck() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      const vin = this.inputTarget.value.replace(/\s/g, '');
      if (vin.length > 2) {
        const that = this;
        Rails.ajax({
          type: 'GET',
          url: `/office/trucks/simple_search?vin=${vin}`,
          success: (data) => {
            if (data.length > 0) {
              that.renderTrucks(data);
            } else {
              that.renderNotFound(vin);
            }
          },
          error: () => {
            alert('Ошибка при попытке найти грузовики по вашему запросу');
          },
        });
      }
    }, 500);
  }

  selectTruck(event) {
    this.vinField.value = event.target.dataset.assemblyVin + ' ' + event.target.dataset.productionVin;

    this.truckIdField.value = event.target.dataset.truckId;

    this.trucksTarget.style.display = 'none';
  }
}
